var map = {
	"./de/translation.json": "./src/locales/de/translation.json",
	"./en/translation.json": "./src/locales/en/translation.json",
	"./es/translation.json": "./src/locales/es/translation.json",
	"./fr/translation.json": "./src/locales/fr/translation.json",
	"./hi/translation.json": "./src/locales/hi/translation.json",
	"./ja/translation.json": "./src/locales/ja/translation.json",
	"./ko/translation.json": "./src/locales/ko/translation.json",
	"./ru/translation.json": "./src/locales/ru/translation.json",
	"./zh/translation.json": "./src/locales/zh/translation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive translation\\.json$";